import * as React from "react";
const SvgTrendDown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13 16h7V9h-2v3.586l-7-7-4 4-5.293-5.293L.293 5.707 7 12.414l4-4L16.586 14H13v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgTrendDown20Px;
